import 'core-js/stable'; // It adds all stable polyfills  which add weight to the bundle but it makes sure android works.

import * as Sentry from '@sentry/react';

import { StrictMode } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import ReactDOM from 'react-dom/client';

import App from './app';
import { env } from './env';

import 'dayjs/locale/fr';
import '@bulthaup/api/prisma/types';

dayjs.extend(isSameOrBefore);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
dayjs.locale('fr');

if (env.VITE_GLITCHTIP_DSN) {
  Sentry.init({
    dsn: env.VITE_GLITCHTIP_DSN,
    tunnel: `${env.VITE_SERVER_URL}/monitoring`,
    sendDefaultPii: false,
    environment: env.VITE_GLITCHTIP_ENVIRONMENT ?? 'unknown',
    beforeSend(event, hint) {
      const error = hint?.originalException as
        | { data?: { code?: string } }
        | undefined;
      // Ne pas remonter les validations metier (TRPCError BAD_REQUEST)
      if (error?.data?.code === 'BAD_REQUEST') return null;
      return event;
    },
  });
  Sentry.setTag('platform', 'frontend');
}

const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
